import { RoomType } from 'pages/common/types';
import { ANY_ROOM_TYPE } from 'pages/common/consts/rooms';

export const RoomTypeLabel = {
  [ANY_ROOM_TYPE]: 'Любая',
  [RoomType.KITCHEN]: 'Кухня',
  [RoomType.BATHROOM]: 'Ванная',
  [RoomType.LIVING_ROOM]: 'Гостиная',
  [RoomType.BEDROOM]: 'Спальня',
  [RoomType.HALLWAY]: 'Прихожая',
  [RoomType.NURSERY]: 'Детская',
  [RoomType.OFFICE_SPACE]: 'Офис',
};

export const RoomTypeDescription = {
  [ANY_ROOM_TYPE]: '31-34 класс, 0,8-14 мм',
  [RoomType.KITCHEN]: '32-34 класс, 8-12 мм, Водостойкий',
  [RoomType.BATHROOM]: '32-34 класс, 8-12 мм, Водостойкий',
  [RoomType.LIVING_ROOM]: '32-34 класс, 8-12 мм, Неводостойкий',
  [RoomType.BEDROOM]: '31–32 класс, 7–10 мм, Неводостойкий',
  [RoomType.HALLWAY]: '32 -34 класс, 8–12 мм, Водостойкий',
  [RoomType.NURSERY]: '31-34 класс, 7-10 мм, Неводостойкий',
  [RoomType.OFFICE_SPACE]: '34 класс, 8–12 мм, Водостойкий',
};

export const roomTypes = [
  {
    name: ANY_ROOM_TYPE,
    label: RoomTypeLabel.any,
    description: RoomTypeDescription.any,
  },
  {
    name: RoomType.KITCHEN,
    label: RoomTypeLabel[RoomType.KITCHEN],
    description: RoomTypeDescription[RoomType.KITCHEN],
  },
  {
    name: RoomType.BATHROOM,
    label: RoomTypeLabel[RoomType.BATHROOM],
    description: RoomTypeDescription[RoomType.BATHROOM],
  },
  {
    name: RoomType.LIVING_ROOM,
    label: RoomTypeLabel[RoomType.LIVING_ROOM],
    description: RoomTypeDescription[RoomType.LIVING_ROOM],
  },
  {
    name: RoomType.BEDROOM,
    label: RoomTypeLabel[RoomType.BEDROOM],
    description: RoomTypeDescription[RoomType.BEDROOM],
  },
  {
    name: RoomType.HALLWAY,
    label: RoomTypeLabel[RoomType.HALLWAY],
    description: RoomTypeDescription[RoomType.HALLWAY],
  },
  {
    name: RoomType.NURSERY,
    label: RoomTypeLabel[RoomType.NURSERY],
    description: RoomTypeDescription[RoomType.NURSERY],
  },
  {
    name: RoomType.OFFICE_SPACE,
    label: RoomTypeLabel[RoomType.OFFICE_SPACE],
    description: RoomTypeDescription[RoomType.OFFICE_SPACE],
  },
];
